import { useMutation } from '@apollo/client';
import { Box, Button, Divider, Link, Stack, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import { UPDATE_AUTHORIZED_EMAIL } from 'schemas/mutation';
import AnimateButton from 'ui-component/extended/AnimateButton';
import { FingerPrintHash } from 'utils/extension';

const Consent = ({ callback, setSignIn, data, isConsentOtp = false }) => {
    const navigate = useNavigate();
    const [updateAuthUser] = useMutation(UPDATE_AUTHORIZED_EMAIL);

    const onSignIn = async () => {
        try {
            callback(true);
            await updateAuthUser({ variables: { body: { email: data.email } } });

            window.close();
            callback(false);
        } catch (error) {
            callback(false);
        }
    };

    return (
        <Box display="flex" flexDirection="column" alignItems="flex-start" justifyContent="flex-start" gap={3}>
            <Typography mt={3} gutterBottom={false}>
                {data.email}
            </Typography>
            <Box display="flex" flexDirection="column" gap={2}>
                <Typography fontSize={16} className="font-poppins text-dark-blue" fontWeight={500} gutterBottom={false}>
                    Diolog would like to access your email.
                </Typography>
                <Stack gap={2} mt={1} px={1}>
                    <Typography fontSize={14} className="font-poppins text-dark-blue">
                        By connecting your Diolog account to the Diolog email extension, you consent Diolog to:
                    </Typography>
                    <Typography>
                        <Typography fontSize={16} className="font-poppins text-dark-blue" fontWeight={500}>
                            Access authorised company emails
                        </Typography>
                        <Typography fontSize={14} className="font-poppins text-dark-blue">
                            Allows Diolog’s email extension to access emails authorised by the administrators of Diolog company accounts
                            that your account is associated with.
                        </Typography>
                    </Typography>
                    <Typography>
                        <Typography fontSize={16} className="font-poppins text-dark-blue" fontWeight={500}>
                            Read email subject lines and content
                        </Typography>
                        <Typography fontSize={14} className="font-poppins text-dark-blue">
                            Diolog will be able to read the emails of subject lines and email content.
                        </Typography>
                    </Typography>
                </Stack>
            </Box>
            <Box mt={2} display="flex" alignItems="center" width="100%" gap={2} justifyContent="center">
                <Box>
                    <Button
                        disableElevation
                        disableRipple
                        fullWidth
                        size="large"
                        type="submit"
                        variant="contained"
                        className="alternate-reversed"
                        onClick={() => setSignIn(true)}
                    >
                        Cancel
                    </Button>
                </Box>
                <Box>
                    <AnimateButton>
                        <Button
                            disableElevation
                            disableRipple
                            fullWidth
                            size="large"
                            type="submit"
                            variant="contained"
                            className="alternate"
                            onClick={onSignIn}
                        >
                            Authorise
                        </Button>
                    </AnimateButton>
                </Box>
            </Box>
            <Stack gap={1} mt={2}>
                <Typography variant="caption" className="font-poppins text-dark-blue" fontWeight={500}>
                    Privacy is important to us.
                </Typography>
                <Typography
                    variant="caption"
                    style={{
                        color: '#676767'
                    }}
                >
                    We respect your privacy. Rest assured, your email data is private and secure to your company account only. Diolog does
                    not have access to communication data in your company portal. See the{' '}
                    <Link
                        href="https://www.diolog.com.au/help/help-articles/privacy-policy"
                        sx={{
                            textDecorationLine: 'underline !important'
                        }}
                        underline="always"
                        target="_blank"
                        rel="noreferrer"
                        color="inherit"
                    >
                        Privacy Policy
                    </Link>{' '}
                    and{' '}
                    <Link
                        href="https://www.diolog.com.au/help/help-articles/customer-general-terms"
                        sx={{ color: 'var(--gray-main)', textDecorationLine: 'underline !important' }}
                        underline="always"
                        target="_blank"
                        rel="noreferrer"
                        color="inherit"
                    >
                        Customer General Terms.
                    </Link>
                </Typography>
                <Box sx={{ mb: 3 }} />
            </Stack>
        </Box>
    );
};

export default Consent;
